/**
 * The base colors for the Soft UI Dashboard PRO React.
 * You can add new color using this file.
 * You can customized the colors for the entire using thie file.
 */

const colors = {
  background: {
    default: "#ffffff",
  },

  text: {
    main: "#333333",
    focus: "#000000",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#f4f4f4",
  },

  black: {
    light: "#111111",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#000000",
    focus: "#333333",
  },

  secondary: {
    main: "#666666",
    focus: "#4d4d4d",
  },

  info: {
    main: "#111111",
    focus: "#000000",
  },

  success: {
    main: "#198754",
    focus: "#146c43",
  },

  warning: {
    main: "#ffc107",
    focus: "#e0a800",
  },

  error: {
    main: "#dc3545",
    focus: "#c82333",
  },

  light: {
    main: "#f8f9fa",
    focus: "#e9ecef",
  },

  dark: {
    main: "#212529",
    focus: "#1a1e21",
  },

  grey: {
    100: "#f8f9fa",
    200: "#e9ecef",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gradients: {
    primary: {
      main: "#000000",
      state: "#333333",
    },

    secondary: {
      main: "#666666",
      state: "#4d4d4d",
    },

    info: {
      main: "#111111",
      state: "#000000",
    },

    success: {
      main: "#198754",
      state: "#146c43",
    },

    warning: {
      main: "#ffc107",
      state: "#e0a800",
    },

    error: {
      main: "#dc3545",
      state: "#c82333",
    },

    light: {
      main: "#f8f9fa",
      state: "#e9ecef",
    },

    dark: {
      main: "#212529",
      state: "#1a1e21",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  alertColors: {
    primary: {
      main: "#000000",
      state: "#333333",
      border: "#cccccc",
    },

    secondary: {
      main: "#666666",
      state: "#4d4d4d",
      border: "#cccccc",
    },

    info: {
      main: "#111111",
      state: "#000000",
      border: "#333333",
    },

    success: {
      main: "#198754",
      state: "#146c43",
      border: "#daf3b9",
    },

    warning: {
      main: "#ffc107",
      state: "#e0a800",
      border: "#fef1c2",
    },

    error: {
      main: "#dc3545",
      state: "#c82333",
      border: "#f9b4b4",
    },

    light: {
      main: "#f8f9fa",
      state: "#e9ecef",
      border: "#dee2e6",
    },

    dark: {
      main: "#212529",
      state: "#1a1e21",
      border: "#c2c8d1",
    },
  },

  badgeColors: {
    primary: {
      background: "#f883dd",
      text: "#a3017e",
    },

    secondary: {
      background: "#e4e8ed",
      text: "#5974a2",
    },

    info: {
      background: "#e4e8ed",
      text: "#111111",
    },

    success: {
      background: "#cdf59b",
      text: "#67b108",
    },

    warning: {
      background: "#fef5d3",
      text: "#fbc400",
    },

    error: {
      background: "#fc9797",
      text: "#bd0000",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      background: "#8097bf",
      text: "#1e2e4a",
    },
  },

  inputColors: {
    borderColor: { main: "#d2d6da", focus: "#35d1f5" },
    boxShadow: "#81e3f9",
    error: "#fd5c70",
    success: "#66d432",
  },

  sliderColors: {
    thumb: { borderColor: "#d9d9d9" },
  },

  circleSliderColors: {
    background: "#d3d3d3",
  },

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
